import { Link, useNavigate } from "react-router-dom";
import {
  ArrowRight,
  Bot,
  FileText,
  Handshake,
  Home,
  Key,
  ShieldCheck,
  User,
} from "lucide-react";
import { useAuth } from "../../lib/auth";
import "../../styles/Hero.css";

const Hero = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleRegistrationClick = (role) => {
    navigate("/register", { state: { role } });
  };

  const publicSpaces = [
    {
      icon: Home,
      title: "Locataire",
      text: "Signaler, comprendre vos droits et préparer une démarche.",
      action: () => handleRegistrationClick("tenant"),
    },
    {
      icon: Key,
      title: "Propriétaire",
      text: "Chercher une sortie constructive avant que le conflit s'aggrave.",
      action: () => handleRegistrationClick("landlord"),
    },
    {
      icon: User,
      title: "Citoyen",
      text: "Être orienté vers les bons outils et les bons interlocuteurs.",
      action: () => handleRegistrationClick("user"),
    },
  ];

  const memberSpaces = [
    {
      icon: FileText,
      title: "Mes démarches",
      text: "Retrouver vos dossiers et vos doléances en cours.",
      action: () => navigate("/my-grievances"),
    },
    {
      icon: Bot,
      title: "Assistant IA",
      text: "Structurer un courrier ou clarifier une situation.",
      action: () => navigate("/chat-ia"),
    },
    {
      icon: User,
      title: "Mon profil",
      text: "Gérer vos informations et vos accès.",
      action: () => navigate("/profile"),
    },
  ];

  const spaceCards = isAuthenticated ? memberSpaces : publicSpaces;

  return (
    <section className="hero-container" aria-label="Accueil NMS06">
      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-copy">
          <div className="scope-badge">
            <ShieldCheck size={16} />
            Plateforme citoyenne, juridique et solidaire
          </div>

          <h1 className="hero-title">
            Défendre ses droits, sans rester seul.
          </h1>

          <p className="hero-subtitle">
            NMS06 accompagne les habitants dans leurs démarches de logement,
            de médiation et d'administration avec une approche humaine renforcée
            par des outils d'IA.
          </p>

          <div className="hero-buttons" aria-label="Actions principales">
            <Link to="/contact" className="hero-btn hero-btn--primary">
              Obtenir de l'aide
              <ArrowRight size={19} />
            </Link>
            <a href="#outils-nms" className="hero-btn hero-btn--secondary">
              Découvrir les outils
            </a>
          </div>

          <div className="hero-trust-list" aria-label="Domaines couverts">
            <span>
              <Handshake size={16} />
              Médiation
            </span>
            <span>
              <Home size={16} />
              Logement
            </span>
            <span>
              <FileText size={16} />
              Courriers et dossiers
            </span>
            <span>
              <Bot size={16} />
              IA solidaire
            </span>
          </div>
        </div>

        <div className="hero-guidance-panel" aria-label="Accès rapides">
          <div className="hero-panel-header">
            <span>Commencer simplement</span>
            <p>
              Choisissez l'entrée qui correspond à votre situation. Les textes
              restent modifiables selon le parcours exact souhaité.
            </p>
          </div>

          <div className="hero-space-list">
            {spaceCards.map((item) => (
              <button
                type="button"
                className="hero-space-card"
                key={item.title}
                onClick={item.action}
              >
                <item.icon size={22} />
                <span>
                  <strong>{item.title}</strong>
                  <small>{item.text}</small>
                </span>
                <ArrowRight size={18} className="hero-space-arrow" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
